<textarea [attr.aria-invalid]="ariaInvalid() || null"
          [attr.aria-label]="ariaLabel()"
          [attr.maxlength]="maxLength()"
          [disabled]="disabled()"
          [id]="id()"
          [placeholder]="placeholder() || ''"
          [readOnly]="readOnly() || null"
          [required]="required()"
          [value]="value()"
          (blur)="onBlur($event)"
          (input)="onInput($event)"></textarea>

<div #dataReplicatedValue aria-hidden="true" data-replicated-value></div>
